import { render } from "./BaseTypeIndexShell.vue?vue&type=template&id=375e344d"
import script from "./BaseTypeIndexShell.vue?vue&type=script&lang=js"
export * from "./BaseTypeIndexShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__